import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";


async function initApp() {
  const app = createApp(App);

  app.use(router);

  await router.isReady();
  app.mount("#app");
}

initApp();
